export default __webpack_public_path__ + "static/media/normal.d694fd63.svg";